import { useState, useEffect } from 'react'
import styled from '@emotion/styled';
import { TopDisplay,Loading } from '../../../../ui-components';
import { FilterDropDown } from '../../Applicants/Applicants';
import { useDispatch, useSelector } from 'react-redux';
import AdminTable from './Table';
import CreateBtn from './CreateButton';
import apiCall from '../../../../utils/apiCall';
import { useQueries } from '@tanstack/react-query';
import { CircularProgress } from '@mui/material';
import { AxiosError } from 'axios';
import styles from '../../Applicants/css/display-applicant.module.css';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';

interface AdminUser {
  UserId: string;
  Email: string;
  RuoteId: number;
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
  RoleList: RoleList;
}

interface AdminUserResponse {
  data: AdminUser[];
}

interface RoleList {
  Roles: string[];
}
interface AdminRole {
  Id: string;
  Name: string;
  NormalizedName: string;
}

interface AdminRoleProps {
  data: AdminRole[];
}


const AdminUsers = () => {
  const tData = useSelector((store:any) => store.adminUser.adminUser);
  const [roleFilter, setRoleFilter] = useState<string>('');
  const [roleData, setRoleData] = useState<any>([]);
  const [selFilter, setSelFilter] = useState<any>(null);
  const [searchData, setSearchData] = useState('')

  const getAdminUsers = async (): Promise<AdminUser[]> => {
    return (await apiCall().get('/Administration/users/GetAdminUsers')).data;
  };

  const getAllRoutes = async (): Promise<AdminRoleProps> => {
    const url = '/Administration/roles/readall';
    return (await apiCall().get(url)); 
};

  const [getAdminUsersQuery, getRolesQuery] = useQueries({
    queries: [
      {queryKey: ['get-admin-users'], queryFn: getAdminUsers},
      {queryKey: ['get-all-roles'], queryFn: getAllRoutes}
    ]
  });

  const getAdminUserError = getAdminUsersQuery?.error as AxiosError;
  const getAdminUserErrorMessage = getAdminUserError?.message;

  useEffect(()=>{
     if(!getRolesQuery?.isLoading && getRolesQuery?.data?.data){
      if(getRolesQuery?.data?.data.length > 0){
        setRoleData(getRolesQuery?.data?.data.map((data: any) => ({name: data?.Name}) ));
      } 
    }
  }, [getRolesQuery?.data?.data, getRolesQuery?.isLoading]);
  
  useEffect(() => {
     if(selFilter){
        setRoleFilter(selFilter?.name);
     }
  },[selFilter]);

  useEffect(() => {
     setRoleFilter('');
  },[tData])

  const filteredData = getAdminUsersQuery?.data?.filter(x => (
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
  ));
  
  //if(isLoading) return <Loading />

  return (
    <Container>
      <TopDisplay title="Admin Users" subTitle="Settings" Btn={<CreateBtn data={getRolesQuery?.data?.data}/>} />
      <InnerContainer >
        <label className={styles.searchForm} ><span className={styles.sI}><SearchIcon/></span><input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' /><button className={styles.rBtn} type="submit"><ReloadIcon/></button></label>
        {/* <FilterDropDown  options={roleData} text="Role" bg="#11643C" color="#fff" /> */}
        {/* <FilterDropDown options={statusOpt} text="Status" bg="#E2E4E9"/> */}
      </InnerContainer>
      {getAdminUsersQuery?.isLoading ? (
        <CircularProgress sx={{
          fontSize: '1rem',
          marginInline: 'auto',
          display: 'block',
          marginBlock: '2rem'
        }}/>
      ) : getAdminUsersQuery?.isError ? (
        <StyledError>{getAdminUserErrorMessage}</StyledError>
      ) : filteredData && filteredData?.length > 0 ? 
      (
        <AdminTable data={searchData.length > 0 ? filteredData :  getAdminUsersQuery?.data} filter={roleFilter} roleData={getRolesQuery?.data?.data}/>
      ) 
      : <NoResult>No Results</NoResult>}
    </Container>
  )
}
export default AdminUsers;

export const Container = styled.div`
  padding: 0 48px 48px;
  width:100%;
`
export const InnerContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled.div`
  margin-block-start: 2rem;
`

